export default __webpack_public_path__ + "static/media/RE active.32902947.svg";